import { Pipe, PipeTransform } from '@angular/core';
import { Post } from './../../models/post';

@Pipe({
    name: 'msgFilter',
    pure: false
})
export class PostMsgPipe implements PipeTransform {
    transform(items: Post[], filter: Post): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter((item: Post) => this.applyFilter(item, filter));
    }
    applyFilter(book: Post, filter: Post): boolean {
        for (let field in filter) {
            // console.log(filter[field]+"       "+book[field]+"  "+(filter[field]==book[field])+"  "+(filter[field]===book[field]))
            if(book[field]){
                if (filter[field]) {
                    if (typeof filter[field] === 'string') {
                        
                      if (book[field].trim().toLowerCase().indexOf(filter[field].trim().toLowerCase()) === -1) {
                        return false;
                      }
                    } else if (typeof filter[field] === 'number') {
                      if (book[field] !== filter[field]) {
                        return false;
                      }
                    }else if ( filter[field] == 'date') {
                        if (book[field] !== filter[field]) {
                          return false;
                        }
                      }
                  }
            }
         
        }
        return true;
      }
}